
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import{  RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';
import MerchantsService from "../../../services/merchants-service.js";
import { agentsList } from "./../../../actions/agent-actions.js";
import AutoPayService from '../../../services/auto-pay.service.js';
import { AutoPayColumns } from './auto-pay.col.js'
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchFilter from  "./../../common/helper/searchFilter.js";
import Confirmation from "../../common/modals/confirmation.component.js";
import { AgentsService, ConfigService } from "../../../services/index.js";
import SelectSearch from "react-select-search";

const AutoPay = () => { 
  const dispatch = useDispatch();
  const [role,setUserRole] = useState('');
  const [status,setStatus] = useState('');
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [distributors, setDistributors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [transaction , setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [row, setRow] = useState({});

  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const changeStatus =(row) => {
    setModalShow(true);
    setRow({
     agent_id: row.agent_id,
     auto_pay: row.auto_pay,
      modalId: "statusChangeAutoPay",
    });
  }
  const [filterData, setFilterData] = useState({
    end_date: '',
    start_date: '',
    customer_id: '',
    agent_id: '',
    payment_method: ''
  });
  const [columns,setColumns] = useState(AutoPayColumns(changeStatus));


  const getAutoPayAgentsList = (e) => {
    
    let service =  AutoPayService.getAutoPayAgents(e)
    
    setLoading(true);
   
    service.then(response => {
      console.log(response)
      const records = response.data.data
      setTransactionData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
  const selectRows = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);
  const updateStatus = (data) => {
    console.log(row)
    if (row.modalId == "statusChangeAutoPay") {
      const suspended = [];
      const resume = [];
      let data = {}
      if (row.auto_pay === true) {
        suspended.push(row.agent_id);
        data.agents = suspended
        data.auto_pay = false
        autoPayAgent(data);
      } else {
        resume.push(row.agent_id);
        data.agents = resume
        data.auto_pay = true
        autoPayAgent(data);
      }
    } else if (row.modalId === "statusChangeAutoPaySuspend") {
      const suspended = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].auto_pay === true) {
          suspended.push(selectedRows[i].agent_id);
        }
      }
      setDataTableKey((prevKey) => prevKey + 1);

      data.agents = suspended
      data.auto_pay = false
      autoPayAgent(data);
      setSelectedRows([])

    } else if (row.modalId == "statusChangeAutoPayResume") {
      const resume = [];
      for (var i = 0; i < selectedRows.length > 0; i++) {
        if (selectedRows[i].auto_pay == false) {
          resume.push(selectedRows[i].agent_id);
        }
      }
      data.agents = resume
      data.auto_pay = true
      setDataTableKey((prevKey) => prevKey + 1);
      autoPayAgent(data);
      setSelectedRows([])

    } 
  };
  const autoPayAgent = (data) => {
    setLoading(true);
    AutoPayService.setAutoPay(data)
      .then((response) => {
        toast.success(MESSAGES.AUTO_PAY);
        getAutoPayAgentsList();
        setLoading(false);
        setModalShow(false);
        setDataTableKey((prevKey) => prevKey + 1);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };
  const suspendMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      modalId: "statusChangeAutoPaySuspend",
    });
  };

  const resumeMultiple = () => {
    setModalShow(true);
    setRow({
      // user_id: row.user_id,
      modalId: "statusChangeAutoPayResume",
    });
  };

  useEffect(() => {
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       setUserRole(userRole)
    }
    getAutoPayAgentsList();
    if(userData.user.data.role.role_code == 'ADMIN') {
        getDistributors();
    }
   
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);
const getDistributors = () => {
    ConfigService.getDistributorDropDown()
    .then((response) => {
      const agents = response.data.data
      const arr = [{name:'All Distributors',value:''}];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].value,
          value: agents[i].key,
        })
      }
      setDistributors(arr);
    })
    .catch((error) => {
    });
   
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'P':
        return 'Pending';
      case 'R':
        return 'Raised';
      case 'RF':
        return 'Refund';
      case 'C':
        return 'Paid';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = transaction && transaction.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(Number(value));
    setDataTableKey((prevKey) => prevKey + 1);
  };
   
    

      useEffect(() => {
          if (filteredData?.length) {
            const element = document.getElementsByClassName("sc-bHCmUC");
            const childElement = element[0].children;
            for (let i = 0; i < childElement?.length; i++) {
              const ele = childElement[i].id.split("-")[1];
              if (Number(ele) % 2 === 0) {
                childElement[i].classList.add("odd-transaction-table");
              } else {
                childElement[i].classList.add("even-transaction-table");
              }
            }
          }
        }, [filteredData]);
      
    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Auto Pay
          </h4>
        <div>
            <div>
             
            </div>
            </div>
          </div>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" >Auto Pay</button>
             
            </div>
          </nav>
          <div className="filterBtn">
                        
          <SearchTable searchTerm={searchTerm} handleSearchChange={handleSearchChange}/>
                        <div>

 
      </div>
                  </div>
                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
                  
                  {userData.user.data.role.role_code == "ADMIN" && (
                <div className="col-md-12 agentDistributor" style={{marginBottom:'10px'}}>
                    <div className="" style={{ textAlign: "left" }}>
                      <SelectSearch
                        search={true}
                        options={distributors}
                        name="customer_id"
                        onChange={getAutoPayAgentsList}
                       
                        placeholder="Select Distributors"
                      />
                      <span class="fa fa-angle-down errspan"></span>
                    </div>
                  
         
                </div>
              )}
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab"  style={{ position: "relative" }}>
            <div className="multi" style={{ left: "18px" }}>
                <a
                  className="nav-link dropdown-toggle news fell jhb"
                  id="navbarDropdown"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  style={{
                    opacity: selectedRows.length > 0 ? 1 : "",
                    pointerEvents: selectedRows.length > 0 ? "auto" : "none",
                  }}
                >
                  <i className="fa fa-ellipsis-h" aria-hidden="true" />
                </a>
                <ul
                  className="dropdown-menu dropdown-menu-end mbv"
                  id="nvb"
                  aria-labelledby="navbarDropdown"
                  style={{}}
                >
                  <li onClick={resumeMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Enable
                    </a>
                  </li>
                  <li onClick={suspendMultiple}>
                    <a
                      className="dropdown-item"
                      href="#!"
                      style={{ fontSize: "13px" }}
                    >
                      Disable
                    </a>
                  </li>
                </ul>
                <span className="DataTables_sort_icon css_right ui-icon ui-icon-triangle-1-n" />
              </div>
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{textAlign: 'right'}}>
                    
      </div>
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              customStyles={customDataTableStyles}
                              onSelectedRowsChange={selectRows}
                              selectableRows

                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      <Confirmation
        show={modalShow}
        onHide={() => setModalShow(false)}
        onSave={(data) => updateStatus(data)}
        status={row.status}
        modalId={row.modalId}
      ></Confirmation>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(AutoPay));